import { GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_ERROR } from "../actions/category"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const getCategories = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATEGORIES_REQUEST:
            return {
                ...state,
                loading: true
            }

        case GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case GET_CATEGORIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}

export default getCategories
